<template>
  <div
    v-block-loading="commentsLoading"
    class="live-commentary-comment"
  >
    <div
      class="live-commentary-comment-collapse"
      @click="handleClose"
    >
      <div><svg-icon icon-class="icon-arrowleft" /></div>
    </div>

    <!-- new message 关闭自动刷新 -->
    <div
      v-if="!isTop && hasNewMessage"
      class="new-message"
      @click="handleScrollTop"
    >
      <span>New Messages</span>
    </div>

    <div
      v-show="!commentsLoading && comments.length"
      ref="commentsPanel"
      class="live-commentary-comment-content"
    >
      <div
        v-for="item in comments"
        :key="item.id"
        :class="['item', {'self': isSelf(item.userId)}]"
      >
        <div
          v-show="!isSelf(item.userId)"
          class="comments-name"
        >
          {{ item.nickName }}
        </div>
        <div
          class="comments-text"
          @touchstart="handleTouchStart(item)"
          @touchend="handleTouchEnd"
        >
          <!-- has quote -->
          <div
            v-if="item.quote"
            :class="['comments-quote', {
              'comments-quote-self': isSelf(item.userId)
            }]"
          >
            <template v-if="item.quote.status === 1">
              <p class="tw-line-clamp-2">{{ item.quote.nickName }}</p>
              <p class="tw-line-clamp-2">{{ item.quote.commentaryText }}</p>
            </template>
            <p
              v-else
              class="comments-quote-hidden"
            >
              Comment no longer exists.
            </p>
          </div>

          <CodeStringBox
            :data="item.commentaryText"
            :code="item.shareCode"
            @codeClick="openCode"
          />
        </div>
      </div>
    </div>

    <div
      v-if="!commentsLoading && !comments.length"
      class="live-commentary-comment-noContent"
    >
      No comments at the moment, be the first now!
    </div>
  </div>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useMatchDetailStore } from 'wap/stores/matchDetail'
import { useCommentsStore } from 'wap/stores/comments'
import cookie from '@ms/utils/cookie.js'
import CodeStringBox from 'wap/components/CodeStringBox'
import 'base/icons/svg/arrowleft.svg'

export default {
  name: 'CommentPanel',
  components: {
    CodeStringBox
  },
  setup() {
    const commentsStore = useCommentsStore()
    const { comments, remainCount, hasNewMessage } = storeToRefs(commentsStore)

    const { getComments, subComments, updateNewMessage, updateQuoteData } = commentsStore

    const matchDetailStore = useMatchDetailStore()
    const { event } = storeToRefs(matchDetailStore)

    return {
      comments,
      remainCount,
      hasNewMessage,
      getComments,
      subComments,
      updateNewMessage,
      updateQuoteData,
      event
    }
  },
  data() {
    return {
      commentsLoading: false,
      loadingMore: false,
      isTop: true,
      timer: null
    }
  },
  watch: {
    hasNewMessage(newV) {
      // 他人更新 如果未滑动页面则滑至最新位置
      if (newV && this.isTop) {
        this.handleScrollTop()
      }
    }
  },
  created() {
    this.fetchGetComments()
  },
  beforeDestroy() {
    this.subComments({ isSub: false, eventId: this.event.eventId })
  },
  methods: {
    async fetchGetComments() {
      this.commentsLoading = true
      this.subComments({ isSub: false, eventId: this.event.eventId })
      try {
        const params = {
          eventId: this.event.eventId,
          eventStatus: this.event.status,
          lastCommentsId: ''
        }
        await this.getComments(params)
        this.commentsLoading = false
        this.subComments({ eventId: this.event.eventId })
        if (this.comments.length) {
          this.$nextTick(() => {
            this.handleScroll()
          })
        }
      } catch (e) {
        console.error(e)
        this.commentsLoading = -1
      }
    },
    async fetchMoreComments() {
      this.loadingMore = true
      try {
        const params = {
          eventId: this.event.eventId,
          eventStatus: this.event.status,
          lastCommentsId: this.comments.length ? this.comments[this.comments.length - 1].id : ''
        }
        await this.getComments(params)
        this.loadingMore = false
      } catch (e) {
        console.error(e)
        this.loadingMore = -1
      }
    },
    handleScroll() {
      const contentEl = document.querySelector('.live-commentary-comment-content')
      if (!contentEl) return
      contentEl.addEventListener('scroll', (e) => {
        const scrolly = e.target.scrollTop || document.body.scrollTop
        const targetHeight = e.target.clientHeight || window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        const scrollHeight = e.target.scrollHeight
        // console.log('e', scrolly+targetHeight, scrollHeight, scrolly, targetHeight)
        if (scrolly + targetHeight + 10 >= scrollHeight && !this.loadingMore && this.remainCount) {
          // 滑到底部请求接口
          this.fetchMoreComments()
        }
        // 滑到顶部隐藏new messages
        if (scrolly < 1) {
          this.isTop = true
          this.updateNewMessage(false)
        } else {
          this.isTop = false
        }
      })
    },
    isSelf(id) {
      const uid = cookie.get('userId')
      return uid === id
    },
    handleClose() {
      this.$emit('close')
    },
    openCode(code) {
      this.$emit('openCode', code)
    },
    handleScrollTop() {
      this.updateNewMessage(false)
      this.$refs.commentsPanel.scrollTop = 0
    },
    // 长按
    handleTouchStart(item) {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        if (!this.isSelf(item.userId)) {
          this.updateQuoteData(item)
          window.mstrace('comments_longpress')
        }
      }, 500)
    },
    handleTouchEnd() {
      clearTimeout(this.timer)
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.live-commentary-comment {
  position: fixed;
  z-index: 15;
  bottom: 60px;
  width: 100%;
  max-width: 750px;
  height: 250px;
  max-height: 250px;
  border-radius: 10px 10px 0 0;
  border-bottom: 1px solid @normal;
  background: #141414;
  box-shadow: 0 -4px 20px 0 rgba(0, 0, 0, 50%);
  color: @white;
  font-size: 14px;

  &-collapse {
    position: absolute;
    z-index: 1;
    top: 7px;
    right: 0;
    left: 0;
    width: fit-content;
    margin: auto;

    & > div {
      width: fit-content;
      transform: rotate(-90deg);
    }

    .svg-icon {
      font-size: 22px;
    }
  }

  &-noContent {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-top: 20%;
    text-align: center;
  }

  &-content {
    width: 328/360 * 100%;
    max-height: 242px;
    padding-top: 22px;
    margin: 0 auto;
    color: @white;
    overflow-y: scroll;

    & .item {
      display: flex;
      width: 100%;
      box-sizing: border-box;
      flex-direction: column;
      padding-bottom: 8px;
      line-height: 18px;
      overflow-x: hidden;
      word-break: break-word;

      & .comments-name {
        position: relative;
        z-index: 2;
        flex: none;
        margin-right: 12px;
        line-height: 26px;
      }

      & .comments-text {
        position: relative;
        top: 2px;
        left: 4px;
        width: fit-content;
        max-width: 280px;
        box-sizing: border-box;
        padding: 5px 8px;
        border-radius: 10px;
        background: #2b2b2b;
      }

      & .comments-text::before {
        position: absolute;
        z-index: 1;
        top: -20px;
        left: -2px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #141414;
        content: "";
      }

      & .comments-text::after {
        position: absolute;
        top: -4px;
        left: 0;
        width: 8px;
        height: 10px;
        border-radius: 0 0 0 4px;
        background: #2b2b2b;
        content: "";
      }

      & .m-codeString {
        display: inline-block;
      }

      & .comments-quote {
        position: relative;
        width: fit-content;
        min-width: 120px;
        box-sizing: border-box;
        padding: 4px 12px;
        border-radius: 8px;
        margin: 4px 0 8px;
        background: #383838;
        color: #e6e6e6;
        font-size: 12px;
        line-height: 14px;

        &::before {
          position: absolute;
          top: 50%;
          left: 1px;
          width: 2px;
          height: 80%;
          border-radius: 30px 0 0 30px;
          background: #ffca27;
          content: "";
          transform: translateY(-50%);
        }

        &-hidden {
          line-height: 42px;
        }

        &-self {
          background: rgba(255, 255, 255, 30%);
          color: #666;

          &::before {
            background: #fff;
          }
        }
      }
    }

    & .self {
      flex-direction: row;
      justify-content: flex-end;
      padding-right: 4px;
      color: @major;

      .m-codeString {
        width: 100%;
      }

      & .comments-text {
        left: -4px;
        background: @primary;
      }

      & .comments-text::before {
        position: absolute;
        z-index: 1;
        top: auto;
        right: -20px;
        bottom: -2px;
        left: auto;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #141414;
        content: "";
      }

      & .comments-text::after {
        position: absolute;
        top: auto;
        right: -4px;
        bottom: 0;
        left: auto;
        width: 8px;
        height: 10px;
        border-radius: 0 0 0 4px;
        background: @primary;
        content: "";
      }

      .m-codeString .is-code {
        color: #333;
      }
    }
  }

  .new-message {
    position: absolute;
    z-index: 2;
    top: 30px;
    right: 0;
    left: 0;
    width: 134/360 * 100%;
    height: 30px;
    border: 1px solid @primary;
    border-radius: 30px;
    margin: auto;
    background: rgba(28, 28, 28, 90%);
    color: @primary;
    cursor: pointer;
    font-size: 12px;
    line-height: 30px;
    text-align: center;

    span {
      position: relative;
      right: 4px;

      &::before,
      &::after {
        position: absolute;
        content: "";
      }

      &::before {
        top: 1px;
        right: -12px;
        width: 6px;
        height: 6px;
        box-sizing: border-box;
        border: 3px solid transparent;
        border-top: none;
        border-bottom: 6px solid @green;
      }

      &::after {
        top: 7px;
        right: -10px;
        width: 2px;
        height: 6px;
        background-color: @green;
      }
    }

    &:active {
      color: #896804;
    }
  }
}

</style>
